import { Platform, Share } from 'react-native';
import type { Profile } from '@ventureroom/core';

export function founderShareText(person: Profile) {
  return [
    `Meet ${person.name} on VentureRoom`,
    `${person.background} · ${person.location}`,
    `Brings: ${person.skills.join(', ')}`,
    `Looking for: ${person.seeking.join(', ')}`,
    person.bio,
    `ventureroom://person/${encodeURIComponent(person.id)}`,
  ]
    .filter(Boolean)
    .join('\n\n');
}

export async function shareFounder(
  person: Profile,
): Promise<'opened' | 'copied' | 'cancelled' | 'unavailable'> {
  const message = founderShareText(person);
  if (Platform.OS !== 'web') {
    const result = await Share.share({ title: `Meet ${person.name}`, message });
    return result.action === Share.dismissedAction ? 'cancelled' : 'opened';
  }
  if (navigator.share) {
    try {
      await navigator.share({ title: `Meet ${person.name}`, text: message });
      return 'opened';
    } catch (error) {
      if (error instanceof Error && error.name === 'AbortError') return 'cancelled';
      // Browsers may expose Web Share but block it in an embedded preview.
    }
  }
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(message);
      return 'copied';
    } catch {
      /* The caller shows selectable text when clipboard access is unavailable. */
    }
  }
  return 'unavailable';
}
